import React from 'react'
import img from '../../assets/trigger.svg'
import { observer } from 'mobx-react'
import { billingStore } from '../../app/stores'
import { Button, BlankSlate } from '../../lib'
import AutoMessageList from './AutoMessageList'

const AutoMessages = () => {
  return (
    <div>
      {billingStore.hasAutoMessagesAccess ? (
        <AutoMessageList />
      ) : (
        <BlankSlate
          img={img}
          title='Auto Messages'>
          <p>
            To create auto messages you'll need to&nbsp;
            <Button styleType='text' to='/account/billing'>
              upgrade your plan
            </Button>.
          </p>
        </BlankSlate>
      )}
    </div>
  )
}

AutoMessages.displayName = 'AutoMessages'

export default observer(AutoMessages)



// WEBPACK FOOTER //
// ./src/channel/automessages/AutoMessages.js